export const parseCookies = (cookies = '') => {
  if (!cookies) return {}

  return cookies.split(/\s*;\s*/).reduce((result, cookie) => {
    const separatorIndex = cookie.indexOf('=')
    if (separatorIndex === -1) return result

    const key = cookie.substring(0, separatorIndex)
    const value = decodeURIComponent(cookie.substring(separatorIndex + 1))

    return { ...result, [key]: value }
  }, {})
}
